import styled from "styled-components";
import { breakpoints, maxWidth } from "../../../styles/variables/breakpoints";

export const FullHeightEl = styled.div`
  height: 100%;
`;

export const ContainerElement = styled.div`
  height: 700px;
  ${maxWidth(breakpoints.lg)} {
    height: 500px;
  }
  ${maxWidth(breakpoints.sm)} {
    height: 400px;
  }
`;
